import { type IPileupParams } from "../../../app-utils/track-shapes/track-pileup-factory.js";
import { CHAR_WIDTH_IN_PIXEL, LANE_PADDING } from "../../../settings/settings.js";

export const flagShapePileupParams: IPileupParams = {
  featureHeight: 16,
  lanePadding: LANE_PADDING,
  labelHeight: null, // the label is not shown above the feature, in fact no label is shown at all
  minShapeWidth: 2,
  charWidthInPixel: CHAR_WIDTH_IN_PIXEL,
  hideLabels: true,
  maxLanes: 4, // will not be used
  boxHeight: 12,
};

export const FORM_NAME = "EDIT_FLAG_FORM";
export const FIELD_FLAG_NAME = "FLAG_NAME";
export const FIELD_FLAG_DESCRIPTION = "FLAG_DESCRIPTION";
export const FIELD_FLAG_COLOR = "FIELD_FLAG_COLOR";
export const FIELD_PROJECT_FLAGS = "FIELD_PROJECT_FLAGS";
